











import { Vue, Component, Prop } from 'vue-property-decorator';

import { ICustomerImportStatus } from '@/models/customer-import';

import CustomerImportSuccess from '@/componentsV2/templates/CustomerImportSuccess/CustomerImportSuccess.vue';

import { ECustomerImportSteps } from '../CustomerImportModal.vue';

@Component({
  components: {
    CustomerImportSuccess
  }
})
export default class ImportSuccess extends Vue {
  @Prop({ default: false }) isVisible?: boolean;
  @Prop() stepProps!: any;

  handleCompleted(customerImportStatus: ICustomerImportStatus) {
    this.$emit('customer-import-event', {
      type: 'goToStep',
      params: { goToStep: ECustomerImportSteps.OFFER_CREATION }
    });
  }
}
